import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterEmptyEntries',
})
export class FilterEmptyEntriesPipe implements PipeTransform {
  transform(items: any[], key?: string): any[] {
    return items?.filter((item) => (key ? !!item[key] : !!item)) ?? [];
  }
}
